// eslint-disable-next-line import/prefer-default-export
import loadable from '@loadable/component'

export const Loading = loadable(() => import('./Loading'))
export default Loading
